/*
* Use this to import swiper in your js files
* - you get Swiper with all modules configured here
*
* @see https://swiper6.vercel.app/get-started
* */
import Swiper, { Autoplay, Controller, EffectFade, Keyboard, Navigation, Pagination } from 'swiper/core'
// configure modules to be used in swiper instances
Swiper.use([Navigation, Pagination, Autoplay, Keyboard, EffectFade, Controller])

export default Swiper
